import SharedLeaderboardPage from "@/features/_shared/pages/LeaderboardPage";
import { dataProps } from "@/models/data.model";
import { FC, JSX } from "react";

import LeaderboardUI from "./components/LeaderboardUI/LeaderboardUI";

const LeaderboardPage: FC<dataProps> = (data): JSX.Element => (
  <SharedLeaderboardPage {...data} UI={LeaderboardUI} withTopThree={false} />
);

export default LeaderboardPage;
